export default {
  root: {
    minHeight: '10vh',
    minWidth: '25vw',
    textAlign: 'center',
  },
};
